import React, { Component } from "react";
import styled from "styled-components";
import FieldOption from "./FieldOption";
import tenis from "../assets/tennis.png";
import basketball from "../assets/basketball.png";
import volleyball from "../assets/volleyball.png";
import multisport from "../assets/multisport.png";
import { FIELD_TYPES } from "../constants";
import Slider from "react-slick";
import { injectIntl } from "react-intl";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";

const Grid = styled.div`
  margin: 0 auto;
  width: 50%;
  padding-top: 3vw;
  @media (max-width: 768px) {
    width: 70%;
  }
  h3 {
    font-size: 24px;
    text-align: center;
    margin: 0;
    color: #000;
    // text-shadow: 1px 1px 1px #000;
    margin-bottom: 24px;
  }
  img {
    max-width: 100%;
  }
  > div {
    position: relative;
    cursor: pointer;
  }
  .slick-dots {
    position: relative;
    top: 24px;
    @media (max-width: 550px) {
      top: -20px;
    }
  }
  .slick-dots li {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
  }

  .slick-dots li button:before,
  .slick-dots li.slick-active button:before {
    color: #004333;
  }
  .slick-prev:before,
  .slick-next:before {
    font-size: 50px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  .slick-prev,
  .slick-next {
    width: 70px;
    height: 70px;
  }
  .slick-prev {
    left: -50px;
  }
  .slick-next {
    right: -50px;
  }
`;

class FieldOptions extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const { intl } = this.props;
    return (
      <Grid>
        <Slider {...settings}>
          <FieldOption
            type={FIELD_TYPES.tennis}
            name={intl.formatMessage({
              id: "field.tennis",
              defaultMessage: "Tenis",
            })}
            img={tenis}
            {...this.props}
          />
          <FieldOption
            type={FIELD_TYPES.basketball}
            name={intl.formatMessage({
              id: "field.basketball",
              defaultMessage: "Koszykówka",
            })}
            img={basketball}
            {...this.props}
          />
          <FieldOption
            type={FIELD_TYPES.volleyball}
            {...this.props}
            name={intl.formatMessage({
              id: "field.volleyball",
              defaultMessage: "Siatkówka",
            })}
            img={volleyball}
          />
          <FieldOption
            type={FIELD_TYPES.multisport}
            {...this.props}
            name="Multisport + Arena"
            img={multisport}
          />
        </Slider>
      </Grid>
    );
  }
}

export default injectIntl(FieldOptions);
